import { RootState } from '@/store/types';
import { createSelector } from 'reselect';

import { isTaskActive } from './constants';

const selectBackgroundTasksState = (state: RootState) => state.backgroundTasks;

export const selectBackgroundTasks = createSelector(
  selectBackgroundTasksState,
  (s) => s.tasks,
);

export const selectCancellingTaskIds = createSelector(
  selectBackgroundTasksState,
  (s) => s.cancellingIds,
);

// "Active" excludes runs the user has just cancelled — they're treated as
// cancelling, not running/queued, until a poll confirms terminal status.
export const selectActiveBackgroundTasks = createSelector(
  selectBackgroundTasks,
  selectCancellingTaskIds,
  (tasks, cancellingIds) =>
    tasks.filter((t) => isTaskActive(t) && !cancellingIds.includes(t.task_id)),
);

export const selectActiveBackgroundTaskCount = createSelector(
  selectActiveBackgroundTasks,
  (tasks) => tasks.length,
);

export const selectHasUnseenCompletedTasks = createSelector(
  selectBackgroundTasksState,
  (s) => s.hasUnseen,
);

export const selectBackgroundTasksLoading = createSelector(
  selectBackgroundTasksState,
  (s) => s.loading,
);

export const selectBackgroundTasksPolledOnce = createSelector(
  selectBackgroundTasksState,
  (s) => s.polledOnce,
);
